import { Logo } from "@/components/site/Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-owo-pink">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-6 px-5 py-14 md:flex-row md:items-center md:justify-between md:px-10">
        <Logo height={30} />
        <p className="text-xs uppercase tracking-[0.14em] text-ink/70">
          © 2026 OWOLOVO Connect Caps - Materiał B2B
        </p>
      </div>
    </footer>
  );
};
